export var DragDirection;
(function (DragDirection) {
    DragDirection["N"] = "N";
    DragDirection["NE"] = "NE";
    DragDirection["NW"] = "NW";
    DragDirection["W"] = "W";
    DragDirection["E"] = "E";
    DragDirection["S"] = "S";
    DragDirection["SW"] = "SW";
    DragDirection["SE"] = "SE";
})(DragDirection || (DragDirection = {}));
